'use client';

import React from 'react';
import { Search, ChevronDown, Download } from 'lucide-react';

interface SalesFilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedPaymentStatus: string;
  onPaymentStatusChange: (status: string) => void;
  selectedMethod: string;
  onMethodChange: (method: string) => void;
  selectedSort: string;
  onSortChange: (sort: string) => void;
  onExport: () => void;
}

export default function SalesFilterBar({
  searchTerm,
  onSearchChange,
  selectedPaymentStatus,
  onPaymentStatusChange,
  selectedMethod,
  onMethodChange,
  selectedSort,
  onSortChange,
  onExport
}: SalesFilterBarProps) {
  return (
    <div className="flex flex-col md:flex-row items-center gap-3">
      {/* Buscador de pedidos / clientes */}
      <div className="relative flex-1 w-full">
        <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400">
          <Search className="w-4 h-4" />
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar por cliente, teléfono o nº pedido..."
          className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200/90 rounded-2xl text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 shadow-sm transition"
        />
      </div>

      {/* Grupo de Dropdowns y Botón de Exportar */}
      <div className="flex items-center gap-2.5 w-full md:w-auto overflow-x-auto pb-1 md:pb-0">
        {/* Dropdown 💲 Pago */}
        <div className="relative">
          <select
            value={selectedPaymentStatus}
            onChange={(e) => onPaymentStatusChange(e.target.value)}
            className="appearance-none bg-white border border-slate-200/90 rounded-2xl pl-3 pr-8 py-2.5 text-xs font-semibold text-slate-700 hover:border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 shadow-sm cursor-pointer transition"
          >
            <option value="ALL">💲 Pago: Todos</option>
            <option value="PAID">💲 Pagado</option>
            <option value="PENDING">💲 Pendiente</option>
          </select>
          <ChevronDown className="w-3.5 h-3.5 text-slate-400 absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none" />
        </div>

        {/* Dropdown 💳 Método */}
        <div className="relative">
          <select
            value={selectedMethod}
            onChange={(e) => onMethodChange(e.target.value)}
            className="appearance-none bg-white border border-slate-200/90 rounded-2xl pl-3 pr-8 py-2.5 text-xs font-semibold text-slate-700 hover:border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 shadow-sm cursor-pointer transition"
          >
            <option value="ALL">💳 Método: Todos</option>
            <option value="EFECTIVO">💵 Efectivo</option>
            <option value="DEBITO">💳 Débito</option>
            <option value="CREDITO">💳 Crédito</option>
            <option value="TRANSFERENCIA">🏦 Transferencia</option>
            <option value="MERCADOPAGO">📱 Mercado Pago</option>
            <option value="OTRO">🏷️ Otro</option>
          </select>
          <ChevronDown className="w-3.5 h-3.5 text-slate-400 absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none" />
        </div>

        {/* Dropdown ⇅ Orden */}
        <div className="relative">
          <select
            value={selectedSort}
            onChange={(e) => onSortChange(e.target.value)}
            className="appearance-none bg-white border border-slate-200/90 rounded-2xl pl-3 pr-8 py-2.5 text-xs font-semibold text-slate-700 hover:border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 shadow-sm cursor-pointer transition"
          >
            <option value="RECENT">⇅ Orden: Más recientes</option>
            <option value="OLDEST">⇅ Más antiguos</option>
            <option value="HIGHEST">⇅ Mayor importe</option>
            <option value="LOWEST">⇅ Menor importe</option>
          </select>
          <ChevronDown className="w-3.5 h-3.5 text-slate-400 absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none" />
        </div>

        {/* Botón de Exportar 📥 */}
        <button
          onClick={onExport}
          className="p-2.5 bg-white border border-slate-200/90 hover:border-slate-300 text-slate-600 hover:text-slate-900 rounded-2xl shadow-sm transition flex items-center justify-center shrink-0"
          title="Exportar arqueo a CSV"
        >
          <Download className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
